import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AlarmsTypes} from '../../types/alarms.types';
import ValidableAlarm = AlarmsTypes.ValidableAlarm;



@Injectable({
  providedIn: 'root'
})
export class AlarmService {

  constructor(private http: HttpClient) {
  }

  getProjectsAlarms(idProject: number, active: boolean = true, alarmType: string = null) {
    let type = alarmType !== null ? '&type=' + alarmType : '';
    let activeNumber: number = active === true ? 1 : 0;
    return this.http.get('projects/' + idProject + '/alarms?active=' + activeNumber + type);
  }

  getProjectsLastAlarms(idProject: number) {
    return this.http.get('projects/' + idProject + '/last-alarms');
  }

  getAlarms(idAlarm: number) {
    return this.http.get('alarms/' + idAlarm);
  }

  deleteAlarm(idAlarm: number) {
    return this.http.delete('alarms/' + idAlarm);
  }

  postAlarm(projectId: number, alarm: any) {
    return this.http.post('projects/' + projectId + '/alarms', alarm);
  }

  putAlarm(idAlarm: number, alarm: any) {
    return this.http.put('alarms/' + idAlarm, alarm);
  }

  getValidableAlarms(status: string = '1') {
    return this.http.get('validable/alarms?status=' + status);
  }

  patchInvalidateAlarm(alarmId: number) {
    return this.http.patch('invalidate/alarms/' + alarmId, null);

  }

  patchValidateAlarm(alarmId: number) {
    return this.http.patch('validate/alarms/' + alarmId, null);
  }


  validableAlarmsFormatter(validableAlarms: ValidableAlarm[]): ValidableAlarm[] {
    validableAlarms.forEach((validableAlarm) => {
      validableAlarm.parentAlarmName = validableAlarm?.parent?.name;
      validableAlarm.parentAlarmId = validableAlarm?.parent?.id;
      validableAlarm.projectName = validableAlarm?.project?.name;
      validableAlarm.projectId = validableAlarm?.project?.id;
      validableAlarm.status = validableAlarm.validation_status;
    });
    return validableAlarms;
  }

}
